/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

/**
 * Creates directive for new solar overlay experience.
 */

function solarOverlayDirective() {
    return {
        restrict: 'E',
        bindToController: true,
        controllerAs: 'vm',
        controller: solarOverlayController,
        template: require('./solarOverlayView.html')
    };
}

solarOverlayController.$inject = ['$scope', '$state', 'AnalyticsService', 'SolarService'];
function solarOverlayController($scope, $state, AnalyticsService, SolarService) {
    function widgetOpened() {
        $scope.isWidgetOpen = true;
    }
    
    function widgetClosed() {
        if ($scope.isWidgetOpen) {

            AnalyticsService.reportEvent('Promo Closed', {type: SolarService.getProjectType()});
            $scope.isWidgetOpen = false
        }
    }

    $scope.closeSolarOverlay = function () {
        SolarService.closeSolarWidget();
    };

    $scope.isWidgetOpenFunc = function () {
        return $scope.isWidgetOpen;
    };

    SolarService.registerSolarWidgetOpenedCallback('open-widget', widgetOpened);
    SolarService.registerSolarWidgetClosedCallback('close-widget', widgetClosed);
}

module.exports = solarOverlayDirective;
